import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  BuildingStorefrontIcon,
  TruckIcon,
  MapPinIcon,
  EnvelopeIcon,
  PhoneIcon,
  ClockIcon,
  ShoppingBagIcon,
  BuildingOffice2Icon,
  CheckCircleIcon,
  ArrowRightIcon,
  ShieldCheckIcon,
  CurrencyRupeeIcon,
} from '@heroicons/react/24/outline';

const styles = `
  .ip { background: #f8faf9; min-height: 70vh; }
  .ip * { box-sizing: border-box; }

  .ip-hero {
    background: #fff;
    border-bottom: 1px solid #e5e7eb;
    padding: 2rem 0 1.75rem;
  }
  .ip-hero-inner { max-width: 1080px; margin: 0 auto; }
  .ip-breadcrumb {
    display: flex; align-items: center; gap: 8px;
    font-size: 0.8rem; color: #6b7280; margin-bottom: 14px;
  }
  .ip-breadcrumb a { color: #16a34a; font-weight: 600; text-decoration: none; }
  .ip-breadcrumb a:hover { text-decoration: underline; }
  .ip-hero h1 {
    margin: 0 0 8px;
    font-size: clamp(1.6rem, 3vw, 2rem);
    font-weight: 800;
    color: #111827;
    letter-spacing: -0.03em;
    line-height: 1.2;
  }
  .ip-hero .lead {
    margin: 0;
    max-width: 640px;
    font-size: 0.98rem;
    line-height: 1.65;
    color: #4b5563;
  }

  .ip-body { padding: 1.75rem 0 3.5rem; }
  .ip-shell { max-width: 1080px; margin: 0 auto; }

  .ip-layout {
    display: grid;
    grid-template-columns: minmax(0, 1.65fr) minmax(280px, 1fr);
    gap: 20px;
    align-items: start;
  }

  .ip-stack { display: flex; flex-direction: column; gap: 20px; }

  .ip-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 22px 22px 20px;
  }
  .ip-card h2 {
    margin: 0 0 14px;
    font-size: 1rem;
    font-weight: 800;
    color: #111827;
    letter-spacing: -0.02em;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .ip-card h2 .accent {
    width: 4px; height: 16px; border-radius: 4px; background: #16a34a; display: inline-block;
  }
  .ip-card p {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.7;
    color: #4b5563;
  }

  .ip-modes {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    margin-top: 16px;
  }
  .ip-mode {
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100%;
    padding: 16px;
    border-radius: 12px;
    background: #f0fdf4;
    border: 1px solid #dcfce7;
  }
  .ip-mode-icon {
    width: 38px; height: 38px; border-radius: 10px;
    background: #16a34a; color: #fff;
    display: grid; place-items: center;
  }
  .ip-mode h3 {
    margin: 0;
    font-size: 0.92rem;
    font-weight: 800;
    color: #14532d;
  }
  .ip-mode p {
    margin: 0;
    font-size: 0.82rem;
    line-height: 1.55;
    color: #3f6212;
  }

  .ip-values {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px 16px;
  }
  .ip-values li {
    display: grid;
    grid-template-columns: 18px 1fr;
    gap: 8px;
    align-items: start;
    font-size: 0.86rem;
    line-height: 1.45;
    color: #374151;
  }
  .ip-values svg { color: #16a34a; margin-top: 1px; }

  .ip-features {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
  .ip-feature {
    text-align: left;
    padding: 14px;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    background: #fafafa;
    min-height: 118px;
  }
  .ip-feature svg { color: #16a34a; margin-bottom: 8px; }
  .ip-feature h3 {
    margin: 0 0 4px;
    font-size: 0.84rem;
    font-weight: 800;
    color: #111827;
  }
  .ip-feature p {
    margin: 0;
    font-size: 0.78rem;
    line-height: 1.45;
    color: #6b7280;
  }

  .ip-side-list { display: flex; flex-direction: column; gap: 10px; }
  .ip-side-item {
    display: grid;
    grid-template-columns: 40px 1fr;
    gap: 12px;
    align-items: center;
    padding: 12px;
    border-radius: 12px;
    background: #f9fafb;
    border: 1px solid #f3f4f6;
    min-height: 64px;
  }
  .ip-side-item .ico {
    width: 40px; height: 40px; border-radius: 10px;
    background: #dcfce7; color: #16a34a;
    display: grid; place-items: center;
  }
  .ip-side-item strong {
    display: block;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #6b7280;
    margin-bottom: 2px;
  }
  .ip-side-item span,
  .ip-side-item a {
    font-size: 0.88rem;
    font-weight: 600;
    color: #111827;
    text-decoration: none;
    word-break: break-word;
  }
  .ip-side-item a:hover { color: #16a34a; }

  .ip-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 18px;
  }
  .ip-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    min-height: 42px;
    padding: 0 16px;
    border-radius: 10px;
    font-size: 0.86rem;
    font-weight: 700;
    text-decoration: none;
    border: 1.5px solid transparent;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  }
  .ip-btn-primary { background: #16a34a; color: #fff; }
  .ip-btn-primary:hover { background: #15803d; }
  .ip-btn-secondary {
    background: #fff;
    color: #14532d;
    border-color: #bbf7d0;
  }
  .ip-btn-secondary:hover { background: #f0fdf4; border-color: #16a34a; }

  .ip-contact-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }
  .ip-contact-tile {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 124px;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    background: #fff;
  }
  .ip-contact-tile .ico {
    width: 40px; height: 40px; border-radius: 10px;
    background: #dcfce7; color: #16a34a;
    display: grid; place-items: center;
    margin-bottom: 12px;
  }
  .ip-contact-tile h3 {
    margin: 0 0 4px;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #6b7280;
  }
  .ip-contact-tile a,
  .ip-contact-tile p {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 700;
    color: #111827;
    text-decoration: none;
    line-height: 1.35;
  }
  .ip-contact-tile a:hover { color: #16a34a; }

  .ip-form {
    display: grid;
    gap: 12px;
  }
  .ip-form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
  .ip-field { display: flex; flex-direction: column; gap: 6px; }
  .ip-field label {
    font-size: 0.78rem;
    font-weight: 700;
    color: #374151;
  }
  .ip-field input,
  .ip-field textarea,
  .ip-field select {
    width: 100%;
    border: 1.5px solid #e5e7eb;
    border-radius: 10px;
    padding: 11px 12px;
    font-size: 0.9rem;
    font-family: inherit;
    color: #111827;
    background: #fff;
    outline: none;
    transition: border-color 0.15s ease;
  }
  .ip-field input:focus,
  .ip-field textarea:focus,
  .ip-field select:focus { border-color: #16a34a; }
  .ip-field textarea { min-height: 110px; resize: vertical; }
  .ip-form-note {
    margin: 0;
    font-size: 0.78rem;
    color: #6b7280;
    line-height: 1.5;
  }
  .ip-success {
    padding: 12px 14px;
    border-radius: 10px;
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    color: #14532d;
    font-size: 0.86rem;
    font-weight: 600;
  }

  @media (max-width: 900px) {
    .ip-layout { grid-template-columns: 1fr; }
    .ip-modes, .ip-values, .ip-features, .ip-contact-grid, .ip-form-row {
      grid-template-columns: 1fr;
    }
    .ip-hero { padding: 1.5rem 0 1.35rem; }
  }
`;

function PageHero({ crumb, title, lead }) {
  return (
    <section className="ip-hero">
      <div className="container">
        <div className="ip-hero-inner">
          <div className="ip-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>{crumb}</span>
          </div>
          <h1>{title}</h1>
          <p className="lead">{lead}</p>
        </div>
      </div>
    </section>
  );
}

function SectionTitle({ children }) {
  return (
    <h2>
      <span className="accent" aria-hidden="true" />
      {children}
    </h2>
  );
}

export function AboutPage() {
  useEffect(() => {
    document.title = 'About ePayhub Store | Grocery & Wholesale in Hyderabad';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        'content',
        "Learn about ePayhub Store — Hyderabad's online grocery marketplace for retail shoppers and B2B wholesale buyers."
      );
    }
  }, []);

  return (
    <main className="ip">
      <style>{styles}</style>
      <PageHero
        crumb="About us"
        title="About ePayhub Store"
        lead="Fresh groceries for homes and reliable wholesale for businesses — delivered across Hyderabad with quality you can trust."
      />

      <div className="ip-body">
        <div className="container">
          <div className="ip-shell">
            <div className="ip-layout">
              <div className="ip-stack">
                <section className="ip-card">
                  <SectionTitle>Who we are</SectionTitle>
                  <p>
                    ePayhub Store is an online grocery and wholesale marketplace based in Hyderabad, Telangana.
                    We help households buy everyday essentials online and help restaurants, retailers, and other
                    businesses source bulk supplies with clear pricing and GST-ready invoicing.
                  </p>

                  <div className="ip-modes">
                    <div className="ip-mode">
                      <div className="ip-mode-icon">
                        <ShoppingBagIcon style={{ width: 18, height: 18 }} />
                      </div>
                      <h3>B2C Retail</h3>
                      <p>Vegetables, dairy, bakery, snacks, drinks, and daily essentials for home delivery.</p>
                    </div>
                    <div className="ip-mode">
                      <div className="ip-mode-icon">
                        <BuildingOffice2Icon style={{ width: 18, height: 18 }} />
                      </div>
                      <h3>B2B Wholesale</h3>
                      <p>Bulk produce, grains, pulses, and restaurant supplies for commercial buyers.</p>
                    </div>
                  </div>
                </section>

                <section className="ip-card">
                  <SectionTitle>Why shop with us</SectionTitle>
                  <ul className="ip-values">
                    {[
                      'One storefront for retail and wholesale',
                      'Local delivery across Hyderabad',
                      'Secure checkout and order tracking',
                      'Fresh assortment at fair prices',
                    ].map((item) => (
                      <li key={item}>
                        <CheckCircleIcon style={{ width: 18, height: 18 }} />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="ip-features" style={{ marginTop: 16 }}>
                    <div className="ip-feature">
                      <TruckIcon style={{ width: 22, height: 22 }} />
                      <h3>Fast delivery</h3>
                      <p>Quick local fulfilment from nearby pickup points.</p>
                    </div>
                    <div className="ip-feature">
                      <CurrencyRupeeIcon style={{ width: 22, height: 22 }} />
                      <h3>Fair pricing</h3>
                      <p>Competitive rates for homes and bulk buyers.</p>
                    </div>
                    <div className="ip-feature">
                      <ShieldCheckIcon style={{ width: 22, height: 22 }} />
                      <h3>Trusted quality</h3>
                      <p>Carefully sourced groceries and daily essentials.</p>
                    </div>
                  </div>

                  <div className="ip-actions">
                    <Link to="/" className="ip-btn ip-btn-primary">
                      Shop now <ArrowRightIcon style={{ width: 15, height: 15 }} />
                    </Link>
                    <Link to="/b2b" className="ip-btn ip-btn-secondary">Explore B2B</Link>
                    <Link to="/contact" className="ip-btn ip-btn-secondary">Contact us</Link>
                  </div>
                </section>
              </div>

              <aside className="ip-card">
                <SectionTitle>Company details</SectionTitle>
                <div className="ip-side-list">
                  <div className="ip-side-item">
                    <div className="ico"><BuildingStorefrontIcon style={{ width: 18, height: 18 }} /></div>
                    <div>
                      <strong>Brand</strong>
                      <span>ePayhub Store</span>
                    </div>
                  </div>
                  <div className="ip-side-item">
                    <div className="ico"><MapPinIcon style={{ width: 18, height: 18 }} /></div>
                    <div>
                      <strong>Location</strong>
                      <span>Hyderabad, Telangana, India</span>
                    </div>
                  </div>
                  <div className="ip-side-item">
                    <div className="ico"><TruckIcon style={{ width: 18, height: 18 }} /></div>
                    <div>
                      <strong>Service area</strong>
                      <span>Hyderabad & nearby localities</span>
                    </div>
                  </div>
                  <div className="ip-side-item">
                    <div className="ico"><ClockIcon style={{ width: 18, height: 18 }} /></div>
                    <div>
                      <strong>Hours</strong>
                      <span>Mon–Sat, 7:00 AM – 10:00 PM</span>
                    </div>
                  </div>
                  <div className="ip-side-item">
                    <div className="ico"><EnvelopeIcon style={{ width: 18, height: 18 }} /></div>
                    <div>
                      <strong>Email</strong>
                      <a href="mailto:kilomart685@gmail.com">kilomart685@gmail.com</a>
                    </div>
                  </div>
                  <div className="ip-side-item">
                    <div className="ico"><PhoneIcon style={{ width: 18, height: 18 }} /></div>
                    <div>
                      <strong>Phone</strong>
                      <a href="tel:+919876543210">+91 98765 43210</a>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export function ContactPage() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    topic: 'Order support',
    message: '',
  });
  const [sent, setSent] = useState(false);

  useEffect(() => {
    document.title = 'Contact ePayhub Store | Hyderabad Grocery & Wholesale';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        'content',
        'Contact ePayhub Store in Hyderabad for grocery orders, B2B wholesale enquiries, delivery support, and account help.'
      );
    }
  }, []);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`[ePayhub Store] ${form.topic}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\nPhone: ${form.phone}\nTopic: ${form.topic}\n\n${form.message}`
    );
    window.location.href = `mailto:kilomart685@gmail.com?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <main className="ip">
      <style>{styles}</style>
      <PageHero
        crumb="Contact"
        title="Contact us"
        lead="Need help with an order, delivery, or wholesale enquiry? Reach the ePayhub Store team — we support retail and B2B customers in Hyderabad."
      />

      <div className="ip-body">
        <div className="container">
          <div className="ip-shell">
            <div className="ip-layout">
              <div className="ip-stack">
                <section className="ip-contact-grid">
                  <div className="ip-contact-tile">
                    <div className="ico"><EnvelopeIcon style={{ width: 18, height: 18 }} /></div>
                    <h3>Email</h3>
                    <a href="mailto:kilomart685@gmail.com">kilomart685@gmail.com</a>
                  </div>
                  <div className="ip-contact-tile">
                    <div className="ico"><PhoneIcon style={{ width: 18, height: 18 }} /></div>
                    <h3>Phone</h3>
                    <a href="tel:+919876543210">+91 98765 43210</a>
                  </div>
                  <div className="ip-contact-tile">
                    <div className="ico"><MapPinIcon style={{ width: 18, height: 18 }} /></div>
                    <h3>Location</h3>
                    <p>Hyderabad, Telangana, India</p>
                  </div>
                  <div className="ip-contact-tile">
                    <div className="ico"><ClockIcon style={{ width: 18, height: 18 }} /></div>
                    <h3>Business hours</h3>
                    <p>Mon–Sat, 7:00 AM – 10:00 PM</p>
                  </div>
                </section>

                <section className="ip-card">
                  <SectionTitle>Send a message</SectionTitle>
                  {sent && (
                    <div className="ip-success" style={{ marginBottom: 12 }}>
                      Your email app should open with the message ready to send.
                    </div>
                  )}
                  <form className="ip-form" onSubmit={onSubmit}>
                    <div className="ip-form-row">
                      <div className="ip-field">
                        <label htmlFor="name">Full name</label>
                        <input id="name" name="name" value={form.name} onChange={onChange} required placeholder="Your name" />
                      </div>
                      <div className="ip-field">
                        <label htmlFor="email">Email</label>
                        <input id="email" type="email" name="email" value={form.email} onChange={onChange} required placeholder="you@example.com" />
                      </div>
                    </div>
                    <div className="ip-form-row">
                      <div className="ip-field">
                        <label htmlFor="phone">Phone</label>
                        <input id="phone" name="phone" value={form.phone} onChange={onChange} placeholder="+91 XXXXX XXXXX" />
                      </div>
                      <div className="ip-field">
                        <label htmlFor="topic">Topic</label>
                        <select id="topic" name="topic" value={form.topic} onChange={onChange}>
                          <option>Order support</option>
                          <option>Delivery update</option>
                          <option>B2B wholesale</option>
                          <option>Account help</option>
                          <option>Other</option>
                        </select>
                      </div>
                    </div>
                    <div className="ip-field">
                      <label htmlFor="message">Message</label>
                      <textarea
                        id="message"
                        name="message"
                        value={form.message}
                        onChange={onChange}
                        required
                        placeholder="Tell us how we can help. Include your order number if relevant."
                      />
                    </div>
                    <p className="ip-form-note">
                      Submitting opens your email app with this message addressed to kilomart685@gmail.com.
                    </p>
                    <div className="ip-actions" style={{ marginTop: 4 }}>
                      <button type="submit" className="ip-btn ip-btn-primary">
                        Send message <ArrowRightIcon style={{ width: 15, height: 15 }} />
                      </button>
                      <a href="tel:+919876543210" className="ip-btn ip-btn-secondary">Call now</a>
                    </div>
                  </form>
                </section>
              </div>

              <aside className="ip-stack">
                <section className="ip-card">
                  <SectionTitle>Quick tips</SectionTitle>
                  <div className="ip-side-list">
                    <div className="ip-side-item">
                      <div className="ico"><ShoppingBagIcon style={{ width: 18, height: 18 }} /></div>
                      <div>
                        <strong>Order help</strong>
                        <span>Include your order number for faster support.</span>
                      </div>
                    </div>
                    <div className="ip-side-item">
                      <div className="ico"><BuildingOffice2Icon style={{ width: 18, height: 18 }} /></div>
                      <div>
                        <strong>Wholesale</strong>
                        <span>Share business name and weekly volume.</span>
                      </div>
                    </div>
                    <div className="ip-side-item">
                      <div className="ico"><TruckIcon style={{ width: 18, height: 18 }} /></div>
                      <div>
                        <strong>Delivery area</strong>
                        <span>Hyderabad and nearby localities.</span>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="ip-card">
                  <SectionTitle>Explore</SectionTitle>
                  <div className="ip-actions" style={{ marginTop: 0 }}>
                    <Link to="/" className="ip-btn ip-btn-secondary">Back to store</Link>
                    <Link to="/about" className="ip-btn ip-btn-secondary">About us</Link>
                    <Link to="/b2b" className="ip-btn ip-btn-secondary">B2B wholesale</Link>
                  </div>
                </section>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
